import { render, staticRenderFns } from "./e-svg-icon.vue?vue&type=template&id=2598dd85"
import script from "./e-svg-icon.vue?vue&type=script&lang=js"
export * from "./e-svg-icon.vue?vue&type=script&lang=js"
import style0 from "./e-svg-icon.vue?vue&type=style&index=0&id=2598dd85&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports